import {EventBus} from '@/utils/EventBus';
import {focusWorkspaceAnchor} from '@/utils/scroll';

/** Blue H1/H2/OTÁZKA chip navigator above the article editor. */
export const ARTICLE_H_BLOCK_NAV_ID = 'articleHBlockNavigator';

export function collapseKeywordAnalysisPanels(): void {
    EventBus.$emit('collapse-keyword-analysis');
}

export function scrollToArticleHBlockNavigator(): void {
    focusWorkspaceAnchor(`#${ARTICLE_H_BLOCK_NAV_ID}`);
}

/** After Generovat / Vylepšit: collapse keyword analysis and show the H-block navigator. */
export function collapseAnalysisAndScrollToHBlocks(): void {
    collapseKeywordAnalysisPanels();
    scrollToArticleHBlockNavigator();
}
